import React from 'react';
import { XIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
export function Chip({
  active,
  onClick,
  children,
  className
}: {
  active?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}) {
  return <button type="button" aria-pressed={active} onClick={onClick} className={cn('rounded-full border px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 ease-out', active ? 'border-primary bg-primary text-on-primary' : 'border-hairline bg-surface text-ink-2 hover:border-primary/40 hover:text-ink', className)} data-id="element-937" data-mp="3si8tngtyhnu5">
      {children}
    </button>;
}
export function RemovableChip({
  children,
  onRemove
}: {
  children: React.ReactNode;
  onRemove: () => void;
}) {
  return <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-soft py-1 pl-3 pr-1.5 text-[13px] font-medium text-primary" data-id="element-938" data-mp="p0qlt9e6ogtq">
      {children}
      <button type="button" onClick={onRemove} aria-label={`Remove filter`} className="rounded-full p-0.5 transition-colors duration-150 ease-out hover:bg-primary/15" data-id="element-939" data-mp="ombcodxl0u2o">
        <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-940" data-mp="envnwhm11wwc" />
      </button>
    </span>;
}